// Pure helper to perform client-side filtering, sorting and pagination for DynamicTable
export default function clientSideSearch({
  initialData = [],
  query = {},
  sort = { sort: null, dir: 'asc' },
  page = 1,
  perPage = 10,
  searchFields = [],
}) {
  // filter
  const searcheableFields = (searchFields || []).filter((field) => field.filter)

  let newData = (initialData || []).filter((row) => {
    if (!query || Object.keys(query).length === 0) {
      return true
    }

    return searcheableFields.every((field) => {
      if (!query[field.name]) {
        return true
      }

      return field.filter(row, query[field.name])
    })
  })

  // sort
  if (sort?.sort) {
    newData = newData.sort((a, b) => {
      const aVal = a[sort.sort]
      const bVal = b[sort.sort]
      if (aVal < bVal) {
        return sort.dir === 'asc' ? -1 : 1
      }
      if (aVal > bVal) {
        return sort.dir === 'asc' ? 1 : -1
      }
      return 0
    })
  }

  // paginate
  const total = initialData.length
  const totalPages = Math.ceil(total / perPage)
  const currentPage = page
  const start = (page - 1) * perPage
  const paged = newData.slice(start, page * perPage)

  const meta = {
    total,
    total_pages: totalPages,
    current_page: currentPage,
    per_page: perPage,
  }

  return { data: paged, meta }
}
